export default __webpack_public_path__ + "static/media/spa-banner-02.40bbf5ee.jpg";